<template>
  <div id="AdminMonitoring" v-if="this.userData.data.username == 'admin'">
    <!-- <Breadcrumb :list="list"/> -->
    <div v-if="loader || missingFieldAndAlertLoader || modalLoader">
      <Loader />
    </div>
    <div class="datepickerwrap card top-card">
      <div class="left-card">
        <div class="custom_dropdown">
          <div @click="showWebsiteMenu = !showWebsiteMenu" class="custom_dropdown_wrap">
            <span class="custom_dropdown_title">{{ selected_website_label }}</span>
            <i class="fa fa-angle-down" style="font-size: 17px"></i>
          </div>
          <div class="custom_websiteMenu" v-if="showWebsiteMenu">
            <span
              style="
                cursor: pointer;
                font-size: 10px;
                float: right;
                color: var(--primary_brand);
                font-weight: 800;
              "
              @click="showWebsiteMenu = false"
              ><i class="fa fa-times"></i> Close
            </span>
            <div
              v-for="d in websiteMenuItems"
              :key="d.optgroup"
              class="custom_websiteMenuItems"
            >
              <div class="custom_optgroup">{{ d.optgroup }}</div>
              <div
                :class="{ active: selected_website == op.key }"
                class="custom_option"
                v-for="op in d.options"
                :key="d.optgroup + '_' + op.key"
              >
                <input
                  @change="customOptionSelected(d.optgroup, op.key, op.label, op.check)"
                  type="checkbox"
                  v-model="op.check"
                />
                <span>{{ op.label }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="datebox w-25">
          <datepicker placeholder="From" @input="refresh" v-model="date.startDate" />
        </div>
        <div class="datebox" style="width: 60px">
          <button @click="refresh" class="btn btn-block primarycolor">
            <i class="fa fa-refresh"></i>
          </button>
        </div>
        <div class="datebox" style="width: max-content">
          <select
            v-model="emailFilter"
            @change="refresh"
            class="form-control text-uppercase customSelect"
          >
            <option value="">All</option>
            <option :value="d" v-for="d in emailList" :key="'emailList_' + d">
              {{ d }}
            </option>
          </select>
        </div>
      </div>
      <div class="right-card">
        <div class="datebox" style="width: 100%">
          <span
            class="alert alert-secondary"
            style="margin-right: 10px; padding: 6px; font-size: 12px"
            >Websites: {{ websiteCount }}, Spiders: {{ spiderCount }}</span
          >
          <b-button
            :variant="successFlag ? 'success' : 'outline-success'"
            style="margin-right: 10px; padding: 6px; font-size: 12px"
            @click="filterSpiders('succeded')"
            >Succeded</b-button
          >
          <b-button
            :variant="failedFlag ? 'danger' : 'outline-danger'"
            style="margin-right: 10px; padding: 6px; font-size: 12px"
            @click="filterSpiders('failed')"
            >Failed</b-button
          >
          <b-button
            :variant="warningFlag ? 'warning' : 'outline-warning'"
            style="
              margin-right: 10px;
              padding: 6px;
              font-size: 12px;
              filter: brightness(90%);
            "
            @click="filterSpiders('warning')"
            >Warning</b-button
          >
          <b-button
            :variant="runningFlag ? 'primary' : 'outline-primary'"
            style="margin-right: 10px; padding: 6px; font-size: 12px"
            @click="filterSpiders('running')"
            >Running</b-button
          >
          <b-button
            :variant="unscheduledFlag ? 'secondary' : 'outline-secondary'"
            style="padding: 6px; font-size: 12px; filter: brightness(80%)"
            @click="filterSpiders('unscheduled')"
            >Unscheduled</b-button
          >
          <!-- <span
            class="alert alert-success"
            style="margin-right: 10px; padding: 6px; font-size: 12px"
            >Succeded</span
          >
          <span
            class="alert alert-danger"
            style="margin-right: 10px; padding: 6px; font-size: 12px"
            >Failed</span
          >
          <span
            class="alert alert-warning"
            style="margin-right: 10px; padding: 6px; font-size: 12px"
            >Warning</span
          >
          <span
            class="alert alert-primary"
            style="margin-right: 10px; padding: 6px; font-size: 12px"
            >Running</span
          >
          <span class="alert alert-secondary" style="padding: 6px; font-size: 12px"
            >Unscheduled</span
          > -->
        </div>
      </div>
    </div>

    <div class="card mx-2" style="overflow-x: auto">
      <div v-if="!spiderData.length" class="alert alert-warning">No Spider data</div>
      <table id="spiderTable" class="rounded-corners w-100">
        <tbody>
          <tr v-for="d in spiderData" :key="'websites_url_' + d.website">
            <td style="width: 100px">{{ websitesUrls[d.website] }}</td>
            <td>
              <div class="row" style="margin: 0">
                <div class="col-md-*" v-for="d2 in d.spiders" :key="d2.spider">
                  <div
                    :title="getTooltip(d2.final_message)"
                    class="alert"
                    :class="{
                      'alert-warning':
                        d2.final_status == 'succeded' && d2.log[d2.log.length - 1].info,
                      'alert-success':
                        d2.final_status == 'succeded' && !d2.log[d2.log.length - 1].info,
                      'alert-danger': d2.final_status == 'failed',
                      'alert-primary': d2.final_status == 'running',
                      'alert-secondary': d2.final_status == 'unscheduled',
                    }"
                    @click="openSpiderModal(d2)"
                    style="
                      cursor: pointer;
                      padding: 4px;
                      margin-right: 4px;
                      margin-bottom: 4px;
                    "
                  >
                    <div style="font-size: 12px">{{ d2.spider }}</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div v-for ="d in spiderData" :key="'websites_url_'+d.website">
        <div class="space-between-header">
           <span class="badge  badge-primary">{{ websitesUrls[d.website] }} ({{ d.website }})</span>
        </div>
        <div class="row">
          <div :class="{'mycols':d.spiders.length>1}" class="col-md-2" v-for="d2 in d.spiders" :key="d2.spider">
            <div class="alert" :class="{'alert-success':d2.final_status=='succeded','alert-danger':d2.final_status=='failed','alert-primary':d2.final_status=='running','alert-secondary':d2.final_status=='unscheduled'}"  @click="openSpiderModal(d2)" style="cursor:pointer;">
              <div style="font-size:12px">{{ d2.spider }} </div>
              <span style="padding:3px;font-size:11px" :class="{'badge-success':d2.final_status=='succeded','badge-danger':d2.final_status=='failed','badge-primary':d2.final_status=='running','badge-secondary':d2.final_status=='unscheduled'}" class="badge">{{ d2.final_status }}</span>
            </div>
          </div>
        
        </div>
      </div> -->
    </div>
    <!-- log section start  -->
    <div class="card mt-3 mx-2" v-show="emailFilter">
      <div class="d-flex justify-content-end">
        <div class="" v-if="emailFilter != ''">
          <date-range-picker
            v-model="missingDataRange"
            opens="left"
            :autoApply="true"
            :locale-data="{ format: 'yyyy-mm-dd' }"
            @update="
              () => {
                getMissingTableData();
                getMissingFieldData();
              }
            "
            style="border: none"
          >
          </date-range-picker>
        </div>
      </div>
      <div style="font-size: 16px" v-if="viewMissingSpiderAlertData.data.length">
        <h3
          style="color: var(--primary_brand)"
          class="mb-4"
          v-if="viewMissingSpiderAlertData.data.length"
        >
          Missing Data
        </h3>
        <table id="missing-spider-data" class="w-100">
          <thead>
            <tr>
              <th
                style="min-width: 120px; font-size: 15px !important"
                class="py-2 text-center"
                v-for="head in Object.keys(viewMissingSpiderAlertData.header)"
                :key="head"
              >
                {{ head }}
              </th>
            </tr>
          </thead>
          <tfoot style="display: table-row-group">
            <tr>
              <th
                style="font-size: 15px !important"
                v-for="d in Object.keys(viewMissingSpiderAlertData.header)"
                :key="d"
              >
                {{ d }}
              </th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="d in viewMissingSpiderAlertData.data" :key="d.tasks">
              <td
                style="font-size: 14px !important"
                class="p-2"
                v-for="head in viewMissingSpiderAlertData.header"
              >
                <span v-if="head == 'missing_data'">
                  <span
                    v-for="date of d[head]"
                    class="badge badge-pill badge-primary mb-1 mr-1"
                    >{{ date }}</span
                  >
                </span>
                <span v-else>{{ d[head] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="space-between-header mt-3"
        v-if="viewMissingFieldData.data.missing_fields.length"
      >
        <h3 class="mb-4" style="color: var(--primary_brand)">Missing Fields</h3>
      </div>
      <div v-if="viewMissingFieldData.data.missing_fields.length">
        <table id="missing-spider-field" class="w-100">
          <thead>
            <tr>
              <th
                style="min-width: 120px; font-size: 15px !important"
                class="py-2 text-center"
                v-for="head in Object.keys(viewMissingFieldData.missing_fields_header)"
                :key="head"
              >
                {{ head }}
              </th>
            </tr>
          </thead>
          <tfoot style="display: table-row-group">
            <tr>
              <th
                style="font-size: 15px !important"
                v-for="d in Object.keys(viewMissingFieldData.missing_fields_header)"
                :key="d"
              >
                {{ d }}
              </th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="d in viewMissingFieldData.data.missing_fields" :key="d.tasks">
              <td
                class="p-2"
                style="font-size: 14px !important"
                v-for="head in viewMissingFieldData.missing_fields_header"
              >
                <span>{{ d[head] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="space-between-header mt-3"
        v-if="viewMissingFieldData.data.empty_fields.length"
        style="font-size: 16px"
      >
        <h3 class="mb-4" style="color: var(--primary_brand)">Empty Fields</h3>
      </div>
      <div v-if="viewMissingFieldData.data.empty_fields.length">
        <table id="empty-spider-field" class="w-100">
          <thead>
            <tr>
              <th
                style="min-width: 120px; font-size: 15px !important"
                class="py-2 text-center"
                v-for="head in Object.keys(viewMissingFieldData.empty_fields_header)"
                :key="head"
              >
                {{ head }}
              </th>
            </tr>
          </thead>
          <tfoot style="display: table-row-group">
            <tr>
              <th
                style="font-size: 15px !important"
                v-for="d in Object.keys(viewMissingFieldData.empty_fields_header)"
                :key="d"
              >
                {{ d }}
              </th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="d in viewMissingFieldData.data.empty_fields" :key="d.tasks">
              <td
                class="p-2"
                style="font-size: 14px !important"
                v-for="head in viewMissingFieldData.empty_fields_header"
              >
                <span v-if="head == 'parametre'">
                  <span
                    class="text-primary linkHover"
                    style="cursor: pointer"
                    @click="
                      openLogTableModal(
                        d[head].split(' , '),
                        'Parameter',
                        d.index,
                        d.missing_fields
                      )
                    "
                    >{{ d[head].split(" , ")[0] }}...</span
                  >
                </span>
                <span v-else>{{ d[head] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      class="customModal"
      size="xl"
      title="Update Empty Field"
      v-model="toggleUpdateModalField"
    >
      <div>
        <input
          type="text"
          placeholder="Enter Processor"
          style="width: 70%"
          class="customInput mt-2"
          v-model="updateFields.processor"
          required
        />
        <input
          type="text"
          placeholder="Enter Processor Type"
          style="width: 70%"
          v-model="updateFields.processorType"
          class="customInput mt-2"
          required
        />
        <input
          type="text"
          placeholder="Enter Processor Model"
          v-model="updateFields.processorModel"
          style="width: 70%"
          class="customInput mt-2"
          required
        />
      </div>
      <button
        class="btn mt-3 primarycolor text-center"
        @click="postUpdateEmptyFieldsData"
      >
        Submit
      </button>
    </b-modal>

    <b-modal class="customModal" size="xl" :title="modalTitle" v-model="isTableDataTrue"
      ><div>
        <div class="mr-1 mb-1" v-for="data in logTableModalData" :key="data">
          <span @click="openUpdateFieldsModal(data)" class="cursorPointer">{{
            data
          }}</span
          ><a :href="data" target="_blank" class="ml-2"
            ><i class="fa fa-external-link"></i></a
          ><br />
        </div>
      </div>
    </b-modal>
    <b-modal
      class="customModal"
      size="lg"
      :title="spidermodalData.spider"
      v-model="isSpiderModal"
    >
      <div id="spiderInfo" class="mt-8">
        <b-card no-body>
          <b-tabs pills card>
            <b-tab title="Logs" active>
              <b-card-text>
                <ul class="list-group" style="display: flex; flex-direction: column">
                  <li
                    :key="d2.spider + '_logs_' + i"
                    v-for="(d2, i) in spidermodalData.log"
                    class="list-group-item d-flex justify-content-between align-items-center mb-2"
                    style="gap: 5px"
                  >
                    <div class="w-25">{{ d2.timestamp }}</div>
                    <div class="d-flex justify-content-center w-50">
                      <div
                        class="spiderlogsmsg"
                        v-html="getTooltip(d2.message, 'onpage')"
                      ></div>
                      <div
                        class="spiderlogsmsg"
                        v-if="d2.info"
                        v-html="getTooltip(d2.info, 'onpage')"
                      ></div>
                    </div>
                    <div
                      :class="{
                        'badge-success': d2.status == 'succeded' && !d2.info,
                        'badge-danger': d2.status == 'failed',
                        'badge-primary': d2.status == 'running',
                        'badge-secondary': d2.status == 'unscheduled',
                        'badge-warning': d2.status == 'succeded' && d2.info,
                      }"
                      class="badge badge-pill w-25"
                      style="max-width: 90px !important"
                    >
                      {{ d2.info ? "warning" : d2.status }}
                    </div>
                  </li>
                </ul>
              </b-card-text>
            </b-tab>
            <b-tab title="Push">
              <b-card-text>
                <div v-if="spidermodalData.flag">
                  <strong>Item Category</strong>
                  <select
                    class="custom-select"
                    id="indexCustomSelect"
                    style="font-size: 12px"
                    v-model="selectedPushItemCategory"
                  >
                    <option value="" disabled hidden>SELECT ITEM CATEGORY</option>
                    <option value="laptop">LAPTOP</option>
                    <option value="desktop">DESKTOP</option>
                    <option value="gaming_laptop">GAMING LAPTOP</option>
                  </select>
                </div>
                <div style="margin-top: 10px">
                  <strong style="color: var(--primary_brand)">Source Date</strong>
                  <datepicker v-model="pushSpider.sourceDate" />
                </div>
                <div style="margin-top: 10px">
                  <strong style="color: var(--primary_brand)">Target Date</strong>
                  <div class="d-flex justify-space-between">
                    <div v-for="(date, idx) of pushSpider.date" :key="idx">
                      <datepicker v-model="date.targetDate" class="mr-2" />
                    </div>
                    <div class="datebox" style="width: 60px">
                      <button
                        @click="addPushTargetDate"
                        class="btn btn-block primarycolor"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 10px">
                  <button
                    class="btn btn-block primarycolor"
                    @click="pushSpiderFn(spidermodalData.spider, spidermodalData.flag)"
                  >
                    Post Now
                  </button>
                </div>
              </b-card-text>
            </b-tab>
            <b-tab title="Run">
              <b-card-text>
                <button
                  class="btn btn-block primarycolor"
                  @click="runSpiderFn(spidermodalData.spider)"
                >
                  Run Spider
                </button>
              </b-card-text>
            </b-tab>
            <b-tab title="Copy">
              <b-card-text>
                <div v-if="spidermodalData.flag">
                  <strong>Item Category</strong>
                  <select
                    class="custom-select"
                    id="indexCustomSelect"
                    style="font-size: 12px"
                    v-model="selectedCopyItemCategory"
                  >
                    <option value="" disabled hidden>SELECT ITEM CATEGORY</option>
                    <option value="laptop">LAPTOP</option>
                    <option value="desktop">DESKTOP</option>
                    <option value="gaming_laptop">GAMING LAPTOP</option>
                  </select>
                </div>
                <div style="margin-top: 10px">
                  <!-- {{ spidermodalData.spider }} -->
                  <strong style="color: var(--primary_brand)">Source Date</strong>
                  <datepicker v-model="copySpider.sourceDate" />
                </div>
                <div style="margin-top: 10px">
                  <strong style="color: var(--primary_brand)">Target Date</strong>
                  <div class="d-flex justify-space-between">
                    <div v-for="(date, idx) of copySpider.date" :key="idx">
                      <datepicker v-model="date.targetDate" class="mr-2" />
                    </div>
                    <div class="datebox" style="width: 60px">
                      <button @click="addTargetDate" class="btn btn-block primarycolor">
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 10px">
                  <button
                    class="btn btn-block primarycolor"
                    @click="
                      scheduleCopySpider(spidermodalData.spider, spidermodalData.flag)
                    "
                  >
                    Copy Now
                  </button>
                </div></b-card-text
              >
            </b-tab>
          </b-tabs>
        </b-card>
      </div>

      <div class="card" style="padding: 10px; margin-top: 20px" v-if="isCopy">
        <h5>Copy</h5>

        <div>
          <strong>Input Date</strong>
          <datepicker v-model="date.startDate" />
        </div>
        <div style="margin-top: 10px">
          <strong>Target Date</strong>
          <datepicker v-model="date.startDate" />
        </div>
        <div style="margin-top: 10px">
          <button class="btn btn-block btn-primary">Copy Now</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue";

export default {
  name: "AdminMonitoring",
  components: {
    Datepicker,
    Loader
  },

  data: function () {
    return {
      data: [],
      spiderData: [],
      spiderCount: 0,
      websiteCount: 0,
      isCopy: false,
      isAllDates: false,
      isSpiderModal: false,
      showWebsiteMenu: false,
      fkey: "all",
      selected_website_label: "All",
      websitesUrls: {
        "https://www.amazon.com": "Amazon US",
        "https://www.amazon.fr": "Amazon France",
        "https://www.amazon.co.it": "Amazon Italy",
        "https://www.amazon.es": "Amazon Spain",
        "https://www.amazon.co.uk": "Amazon UK",
        "https://www.amazon.de": "Amazon Germany",
        "https://www.harveynorman.com.au": "Harvey Norman AU",
        "https://www.bestbuy.com": "Bestbuy",
        "https://www.newegg.com": "Newegg",
        "https://www.microcenter.com": "Microcenter",
        "https://www.currys.co.uk": "Curry's",
        "https://www.costco.com": "Costco",
        "https://www.walmart.com": "Walmart",
        "https://store.hp.com/us": "HP US",
        "https://global.jd.com": "JD",
        "https://store.asus.com/us": "ASUS",
        "https://www.dell.com/en-us": "Dell US",
        "https://www.dell.com/en-uk": "Dell UK",
        "https://store.acer.com/en-us": "Acer",
        "https://store.hp.com/UKStore": "HP UK",
        "https://www8.hp.com/jp": "HP Japan",
        "https://www.lenovo.com/us": "Lenovo US",
        "https://www.lenovo.com/gb": "Lenovo UK",
        "https://www.lenovo.com/de": "Lenovo Germany",
        "https://www.mediamarkt.de": "MediaMarkt",
        "https://store.hp.com/us#commercial": "Commercial HP US",
        "https://www.lenovo.com/us#commercial": "Commercial Lenovo US",
        "https://www.lenovo.com/de#commercial": "Commercial Lenovo Germany ",
        "https://store.hp.com/GermanyStore#commercial": "Commercial HP Germany",
        "https://www.cdw.com": "CDW",
        "https://www.insight.com/en-US": "Insight",
        "https://www.lenovo.com/fr#commercial": "Commercial Lenovo France",
        "https://store.hp.com/FranceStore#commercial": "Commercial HP France",
        "https://store.hp.com/UKStore#commercial": "Commercial HP UK",
        "https://www.lenovo.com/gb#commercial": "Commercial Lenovo UK",
        "https://www.lenovo.com/fr": "Lenovo France",
        "https://store.hp.com/mx-es": "HP Mexico",
        "https://store.hp.com/FranceStore": "HP France",
        "https://br-store.acer.com": "Acer Brazil",
        "https://www.lenovo.com/au": "Lenovo Australia",
        "https://s.lenovo.com.cn": "Lenovo China",
        "https://www.asus.com/fr": "Asus France",
        "https://www.dell.com/en-au": "Dell Australia",
        "https://www.dell.com/ja-jp": "Dell Japan",
        "https://fmv.fccl.fujitsu.com": "Fujitsu Japan",
        "https://www.nec-lavie.jp": "NEC Japan",
        "https://www.hpstore.cn#commercial": "Commercial HP China",
        "https://www.lenovo.com/jp#commercial": "Commercial Lenovo Japan",
        "https://b2b.lenovo.com.cn#commercial": "Commercial Lenovo China",
        "https://www8.hp.com/jp#commercial": "Commercial HP Japan",
        "https://www.shi.com": "SHI",
        "https://www.connection.com": "PC Connection",
        "https://www.bechtle.com": "Bechtle",
        "https://www.asus.com": "ASUS WW",
        "https://www.technoworld.com": "technoworld",
        "https://www.inmac-wstore.com": "inmac",
        "https://www.dustin.no": "Dustin Nordics Norway",
        "https://www.dustin.se": "Dustin Nordics Sweden",
        "https://www.dustin.fi": "Dustin Nordics Finland",
        "https://www.dustin.dk": "Dustin Nordics Denmark",
      },
      websiteMenuItems: [
        {
          optgroup: "RETAIL",
          options: [
            { key: "all", label: "All" },
            { key: "https://www.amazon.com", label: "Amazon US", check: false },
            { key: "https://www.amazon.fr", label: "Amazon France", check: false },
            { key: "https://www.amazon.co.it", label: "Amazon Italy", check: false },
            { key: "https://www.amazon.es", label: "Amazon Spain", check: false },
            { key: "https://www.amazon.co.uk", label: "Amazon UK", check: false },
            { key: "https://www.amazon.de", label: "Amazon Germany", check: false },
            { key: "https://www.bestbuy.com", label: "Best Buy US", check: false },
            { key: "https://www.newegg.com", label: "Newegg", check: false },
            { key: "https://www.microcenter.com", label: "Microcenter", check: false },
            { key: "https://www.costco.com", label: "Costco US", check: false },
            { key: "https://www.currys.co.uk", label: "Curry's UK", check: false },
            {
              key: "https://www.harveynorman.com.au",
              label: "Harvey Norman AU",
              check: false,
            },
            { key: "https://global.jd.com", label: "JD GC", check: false },
            { key: "https://www.mediamarkt.de", label: "MediaMarkt DE", check: false },
            { key: "https://www.walmart.com", label: "Walmart US", check: false },
          ],
        },
        {
          optgroup: "CONSUMER OEM",
          options: [
            { key: "all", label: "All", check: false },
            { key: "https://br-store.acer.com", label: "Acer Brazil", check: false },
            { key: "https://store.acer.com/en-us", label: "Acer US", check: false },
            { key: "https://www.asus.com/fr", label: "ASUS France", check: false }, //check review
            { key: "https://store.asus.com/us", label: "ASUS US", check: false },
            { key: "https://www.asus.com", label: "ASUS WW", check: false },
            { key: "https://www.dell.com/en-au", label: "Dell Australia", check: false },
            { key: "https://www.dell.com/ja-jp", label: "Dell Japan", check: false },
            { key: "https://www.dell.com/en-us", label: "Dell US", check: false },
            { key: "https://www.dell.com/en-uk", label: "Dell UK", check: false },
            { key: "https://fmv.fccl.fujitsu.com", label: "Fujitsu Japan", check: false }, //check review
            { key: "https://store.hp.com/FranceStore", label: "HP France", check: false },
            { key: "https://www8.hp.com/jp", label: "HP Japan", check: false },
            { key: "https://store.hp.com/mx-es", label: "HP Mexico", check: false },
            { key: "https://store.hp.com/UKStore", label: "HP UK", check: false },
            { key: "https://store.hp.com/us", label: "HP US", check: false },
            { key: "https://www.lenovo.com/au", label: "Lenovo Australia", check: false },
            { key: "https://s.lenovo.com.cn", label: "Lenovo China", check: false }, //check review
            { key: "https://www.lenovo.com/fr", label: "Lenovo France", check: false },
            { key: "https://www.lenovo.com/de", label: "Lenovo Germany", check: false },
            { key: "https://www.lenovo.com/gb", label: "Lenovo UK", check: false },
            { key: "https://www.lenovo.com/us", label: "Lenovo US", check: false },
            { key: "https://www.nec-lavie.jp", label: "NEC Japan", check: false }, //check review
          ],
        },
        {
          optgroup: "COMMERCIAL OEM",
          options: [
            { key: "all", label: "All", check: false },
            {
              key: "https://www.hpstore.cn#commercial",
              label: "Commercial HP China",
              check: false,
            }, //check review
            {
              key: "https://store.hp.com/FranceStore#commercial",
              label: "Commercial HP France",
              check: false,
            },
            {
              key: "https://store.hp.com/GermanyStore#commercial",
              label: "Commercial HP Germany",
              check: false,
            },
            {
              key: "https://www8.hp.com/jp#commercial",
              label: "Commercial HP Japan",
              check: false,
            }, //check review
            {
              key: "https://store.hp.com/UKStore#commercial",
              label: "Commercial HP UK",
              check: false,
            },
            {
              key: "https://store.hp.com/us#commercial",
              label: "Commercial HP US",
              check: false,
            },
            {
              key: "https://b2b.lenovo.com.cn#commercial",
              label: "Commercial Lenovo China",
              check: false,
            }, //check review
            {
              key: "https://www.lenovo.com/fr#commercial",
              label: "Commercial Lenovo France",
              check: false,
            },
            {
              key: "https://www.lenovo.com/de#commercial",
              label: "Commercial Lenovo Germany",
              check: false,
            },
            {
              key: "https://www.lenovo.com/jp#commercial",
              label: "Commercial Lenovo Japan",
              check: false,
            }, //check review
            {
              key: "https://www.lenovo.com/gb#commercial",
              label: "Commercial Lenovo UK",
              check: false,
            },
            {
              key: "https://www.lenovo.com/us#commercial",
              label: "Commercial Lenovo US",
              check: false,
            },
          ],
        },
        {
          optgroup: "COMMERCIAL RESELLER",
          options: [
            { key: "all", label: "All", check: false },
            { key: "https://www.bechtle.com", label: "Bechtle", check: false },
            { key: "https://www.cdw.com", label: "CDW", check: false },
            { key: "https://www.inmac-wstore.com", label: "Inmac", check: false },
            { key: "https://www.insight.com/en-US", label: "Insight", check: false },
            { key: "https://www.connection.com", label: "PC Connection", check: false },
            { key: "https://www.shi.com", label: "SHI", check: false },
            { key: "https://www.technoworld.com", label: "TechnoWorld", check: false },
            {
              key: "https://www.dustin.no",
              label: "Dustin Nordics Norway",
              check: false,
            },
            {
              key: "https://www.dustin.se",
              label: "Dustin Nordics Sweden",
              check: false,
            },
            {
              key: "https://www.dustin.fi",
              label: "Dustin Nordics Finland",
              check: false,
            },
            {
              key: "https://www.dustin.dk",
              label: "Dustin Nordics Denmark",
              check: false,
            },
          ],
        },
      ],
      moment: moment,
      userData: JSON.parse(localStorage.getItem("reviewUserData")),
      customData: JSON.parse(localStorage.getItem("reviewCustomData")),
      loader: false,
      missingFieldAndAlertLoader: false,
      modalLoader: false,
      selected_website: "https://store.hp.com/us",
      date: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      device: "laptop",
      tableData: {
        row: [
          { key: "product_name", label: "Product Name", isDropdown: false },
          { key: "processor_type", label: "Processor Type", isDropdown: false },
          { key: "last_updated", label: "Last Updated", isDropdown: false },
          { key: "cpu_logo", label: "CPU Logo", isDropdown: true },
          { key: "gpu_logo", label: "GPU Logo", isDropdown: true },
          { key: "nomenclature", label: "Nomenclature", isDropdown: true },
        ],
        data: [],
      },
      saveTrack: [],
      saveData: [],
      selected_website_array: [],
      selected_website_channel_array: [],
      spidermodalData: {},
      emailList: [],
      emailFilter: "",
      selectedCopyItemCategory: "",
      selectedPushItemCategory: "",
      copySpider: {
        sourceDate: moment().format("YYYY-MM-DD"),
        date: [
          {
            targetDate: moment().format("YYYY-MM-DD"),
          },
        ],
        targetDateList: [],
      },
      pushSpider: {
        sourceDate: moment().format("YYYY-MM-DD"),
        date: [
          {
            targetDate: moment().format("YYYY-MM-DD"),
          },
        ],
        targetDateList: [],
      },
      successFlag: false,
      failedFlag: false,
      warningFlag: false,
      runningFlag: false,
      unscheduledFlag: false,
      viewSpiderList: [],
      viewMissingSpiderAlertData: {
        header: {},
        data: [],
      },
      viewMissingFieldData: {
        missing_fields_header: {},
        empty_fields_header: {},
        data: {
          empty_fields: [],
          missing_fields: [],
        },
      },
      missingDataRange: {
        startDate: moment().subtract(1, "weeks").format("YYYY-MM-DD"),
        endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      isTableDataTrue: false,
      logTableModalData: [],
      modalTitle: "",
      toggleUpdateModalField: false,

      updateFields: {
        processor: "",
        processorType: "",
        processorModel: "",
        field: "",
        index: "",
        link: "",
      },
    };
  },
  mounted() {
    for (let [i, r] of this.websiteMenuItems.entries()) {
      for (let [ii, rr] of r.options.entries()) {
        rr.check = true;
        if (rr.key != "all") {
          this.selected_website_label = "All";
          this.selected_website_array.push(rr.key);
          this.selected_website_channel_array.push(this.websitesUrls[rr.key]);
        }
      }
    }
    this.refresh();
  },
  methods: {
    refresh() {
      this.viewMissingFieldData = {
        missing_fields_header: {},
        empty_fields_header: {},
        data: {
          empty_fields: [],
          missing_fields: [],
        },
      };
      this.showWebsiteMenu = false;
      this.saveData = [];
      this.saveTrack = [];
      this.tableData.data = [];
      this.getEmailList();
      this.getData();
      this.toggleFlags(true);
      if (this.emailList.length) this.getSpiderApiList();
    },
    addTargetDate() {
      let temp = {
        targetDate: moment().format("YYYY-MM-DD"),
      };
      this.copySpider.date.push(temp);
    },
    getSpiderApiList() {
      let self = this;
      this.loader = true;
      const url = "/api/spider/alert/spiderlist";
      let payload = {
        email_id: self.emailFilter,
      };
      self.$http.post(url, payload).then(
        (response) => {
          self.viewSpiderList = response.body.data;
          if (self.emailFilter != "") {
            self.getMissingTableData();
            self.getMissingFieldData();
          }
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    getMissingTableData() {
      $("#missing-spider-data").DataTable().destroy();
      let self = this;
      this.missingFieldAndAlertLoader = true;
      self.viewMissingSpiderAlertData = {
        header: {},
        data: [],
      };
      const url = "/api/spider/alert";
      let payload = {
        start_date: moment(this.missingDataRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.missingDataRange.endDate).format("YYYY-MM-DD"),
        spider_list: self.viewSpiderList,
      };
      self.$http.post(url, payload).then(
        (response) => {
          self.viewMissingSpiderAlertData = response.body;
          self.$nextTick(() => {
            self.initDt2("#missing-spider-data");
          });
          this.missingFieldAndAlertLoader = false;
        },
        (err) => {
          self.missingFieldAndAlertLoader = false;
          console.log("err");
        }
      );
    },
    getMissingFieldData() {
      $("#missing-spider-field").DataTable().destroy();
      $("#empty-spider-field").DataTable().destroy();

      let self = this;
      self.viewMissingFieldData = {
        missing_fields_header: {},
        empty_fields_header: {},
        data: {
          empty_fields: [],
          missing_fields: [],
        },
      };
      this.missingFieldAndAlertLoader = true;
      const url = "/api/spider/alert/missingfields";
      let payload = {
        spider_list: self.viewSpiderList,
        start_date: moment(this.missingDataRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.missingDataRange.endDate).format("YYYY-MM-DD"),
      };
      self.$http.post(url, payload).then(
        (response) => {
          self.viewMissingFieldData = response.body;
          self.$nextTick(() => {
            self.initDt2("#missing-spider-field");
            self.initDt2("#empty-spider-field");
          });
          self.missingFieldAndAlertLoader = false;
        },
        (err) => {
          self.missingFieldAndAlertLoader = false;
          console.log("err");
        }
      );
    },

    initDt2(tableId) {
      let self = this;
      let search = require("../../../public/Icons_SVG/Search.svg");
      this.loader = true;
      $(tableId).DataTable({
        language: {
          search: "",
          searchPlaceholder: "Search",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
        pagingType: "full_numbers",
        searching: true,
        sorting: [[1, "desc"]],

        initComplete: function () {
          $(tableId).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
          this.api()
            .columns()
            .every(function () {
              var column = this;
              var select = $('<select><option value="">All</option></select>')
                .appendTo($(column.footer()).empty())
                .on("change", function () {
                  var val = $.fn.dataTable.util.escapeRegex($(this).val());

                  column.search(val ? "^" + val + "$" : "", true, false).draw();
                });

              let arr = [];
              let sortedArr = [];
              column
                .data()
                .unique()
                .sort()
                .each(function (d, j) {
                  var myVal = $(d).text();
                  arr.push(myVal);
                });

              sortedArr = arr.sort((a, b) =>
                a.localeCompare(b, navigator.languages[0] || navigator.language, {
                  numeric: true,
                  ignorePunctuation: true,
                })
              );

              for (let [idx, ds] of sortedArr.entries()) {
                select.append('<option value="' + ds + '">' + ds + "</option>");
              }
            });
        },
      });
      $(tableId + "_filter > label").append(
        `<div class='search_icon'><img src='${search}' /></div>`
      );
      this.loader = false;
    },
    scheduleCopySpider(spiderName, flag) {
      let self = this;
      this.modalLoader = true;
      this.copySpider.targetDateList = [];
      for (let date of this.copySpider.date) {
        this.copySpider.targetDateList.push(moment(date.targetDate).format("YYYY-MM-DD"));
      }
      const url = "/api/spider/copy";
      const payload = {
        source_date: moment(self.copySpider.sourceDate).format("YYYY-MM-DD"),
        target_date: this.copySpider.targetDateList,
        spider_name: spiderName,
      };

      if (flag) payload.item_category = this.selectedCopyItemCategory;
      console.log(payload);
      self.$http.post(url, payload).then(
        (response) => {
          this.copySpider.sourceDate = moment().format("YYYY-MM-DD");
          this.copySpider.date = [{ targetDate: moment().format("YYYY-MM-DD") }];
          self.modalLoader = false;
          this.$bvToast.toast(`Success`, {
            autoHideDelay: 5000,
            variant: "success",
          });
        },
        (err) => {
          self.modalLoader = false;
          console.log("err");
        }
      );
    },
    addPushTargetDate() {
      let temp = {
        targetDate: moment().format("YYYY-MM-DD"),
      };
      this.pushSpider.date.push(temp);
    },
    pushSpiderFn(spiderName, flag) {
      let self = this;
      this.modalLoader = true;
      this.pushSpider.targetDateList = [];
      for (let date of this.pushSpider.date) {
        this.pushSpider.targetDateList.push(moment(date.targetDate).format("YYYY-MM-DD"));
      }
      const url = "/api/spider/push";
      const payload = {
        source_date: moment(self.pushSpider.sourceDate).format("YYYY-MM-DD"),
        target_date: this.pushSpider.targetDateList,
        spider_name: spiderName,
      };

      if (flag) payload.item_category = this.selectedPushItemCategory;
      console.log(payload);
      self.$http.post(url, payload).then(
        (response) => {
          this.pushSpider.sourceDate = moment().format("YYYY-MM-DD");
          this.pushSpider.date = [{ targetDate: moment().format("YYYY-MM-DD") }];
          self.modalLoader = false;
          this.$bvToast.toast(`Success`, {
            autoHideDelay: 5000,
            variant: "success",
          });
        },
        (err) => {
          self.modalLoader = false;
          console.log("err");
        }
      );
    },
    runSpiderFn(spiderName) {
      const url = "/api/spider/runspider";
      const payload = {
        spider_name: spiderName,
      };
      this.modalLoader = true;

      this.$http.post(url, payload).then(
        (response) => {
          this.modalLoader = false;
          this.$bvToast.toast(`Success`, {
            autoHideDelay: 5000,
            variant: "success",
          });
        },
        (err) => {
          this.modalLoader = false;
          this.$bvToast.toast(`SpiderRun Failed!`, {
            autoHideDelay: 5000,
            variant: "danger",
          });
        }
      );
    },
    filterNow() {
      let self = this;
      self.spiderData = [];
      if (self.fkey != "all") {
        for (let [i, r] of self.spiderDataFull.entries()) {
          let arr = [];
          for (let [ii, rr] of r.spiders.entries()) {
            if (["unscheduled", "running", "failed"].includes(self.fkey)) {
              if (rr.final_status == self.fkey) {
                arr.push(rr);
              }
            } else {
              if (self.fkey == "succeded") {
                if (rr.final_status == "succeded" && !rr.log[rr.log.length - 1].info) {
                  arr.push(rr);
                }
              }
              if (self.fkey == "warning") {
                if (rr.final_status == "succeded" && rr.log[rr.log.length - 1].info) {
                  arr.push(rr);
                }
              }
            }
          }
          if (arr.length) self.spiderData.push({ spiders: arr, website: r.website });
        }
      } else {
        self.spiderData = self.spiderDataFull;
      }
      this.toggleFlags(false);
      if (this.fkey == "succeded") this.successFlag = true;
      if (this.fkey == "warning") this.warningFlag = true;
      if (this.fkey == "running") this.runningFlag = true;
      if (this.fkey == "unscheduled") this.unscheduledFlag = true;
      if (this.fkey == "failed") this.failedFlag = true;
      if (this.fkey == "all") this.toggleFlags(true);
      this.spiderDataFull = JSON.parse(JSON.stringify(this.spiderData));
    },
    getTooltip(d, type) {
      if (type != "onpage") {
        let str = d.replace(/,/g, ",\n");
        return str;
      } else {
        let str = d
          .replace(/</g, "<|")
          .replace(/>/g, "|>")
          .replace(/,/g, ",<br/>")
          .replace(/\n/g, ",<br/>");
        return str;
      }
    },
    openSpiderModal(d) {
      this.isSpiderModal = true;
      this.spidermodalData = d;
    },
    openUpdateFieldsModal(link) {
      this.toggleUpdateModalField = true;
      this.updateFields.link = link;
    },
    postUpdateEmptyFieldsData() {
      let self = this;
      this.loader = true;
      let fieldsUpdate = {};


      if (this.updateFields.processor.length)
        fieldsUpdate.processor = this.updateFields.processor;

      if (this.updateFields.processorModel.length)
        fieldsUpdate.processor_type = this.updateFields.processorType;

      if (this.updateFields.processorModel.length)
        fieldsUpdate.processor_model = this.updateFields.processorModel;

      let payload = {
        link: self.updateFields.link.trim(),
        field: self.updateFields.field,
        index: self.updateFields.index,
        field_to_update: fieldsUpdate,
      };
      // console.log("check all payload of updtae", payload);
      const url = "/api/spider/alert/fixingemptyfields";
      self.$http.post(url, payload).then(
        (response) => {
          this.$bvToast.toast(`Updated`, {
            autoHideDelay: 5000,
            variant: "success",
          });
          self.updateFields.processorModel = "";
          self.updateFields.processorType = "";
          self.updateFields.processor = "";
          self.updateFields.link = "";
          self.loader = false;
          self.toggleUpdateModalField = false;
        },
        (err) => {
          self.loader = false;
          alert("Error in Saving");
          this.$bvToast.toast(`Error in updated`, {
            autoHideDelay: 5000,
            variant: "danger",
          });
        }
      );
    },
    openLogTableModal(d, title, index, missingFields) {
      this.isTableDataTrue = true;
      this.logTableModalData = d;
      this.modalTitle = title;
      this.updateFields.index = index;
      this.updateFields.field = missingFields;
    },
    customOptionSelected(optgroup, value, label, check) {
      let self = this;
      if (value != "all") {
        if (check) {
          self.selected_website_label = label;
          this.selected_website_array.push(value);
          this.selected_website_channel_array.push(this.websitesUrls[value]);
          // for (let [i, r] of this.websiteMenuItems.entries())
          // {
          //   if(r.optgroup == optgroup)
          //   {
          //     let allTick = true
          //     for (let [ii, rr] of r.options.entries())
          //     {
          //       if(rr.check == false) allTick = false
          //     }
          //     if(allTick)
          //     {
          //       r.options[0].check = true

          //     }
          //   }
          // }
        } else {
          if (this.selected_website_array.includes(value))
            this.selected_website_array.splice(
              this.selected_website_array.indexOf(value),
              1
            );
          if (this.selected_website_channel_array.includes(this.websitesUrls[value]))
            this.selected_website_channel_array.splice(
              this.selected_website_channel_array.indexOf(this.websitesUrls[value]),
              1
            );
          for (let [i, r] of this.websiteMenuItems.entries()) {
            if (r.optgroup == optgroup) {
              r.options[0].check = false;
            }
          }
        }
      } else {
        for (let [i, r] of this.websiteMenuItems.entries()) {
          if (r.optgroup == optgroup) {
            for (let [ii, rr] of r.options.entries()) {
              if (check) {
                rr.check = true;
                if (rr.key != "all" && !this.selected_website_array.includes(rr.key)) {
                  this.selected_website_array.push(rr.key);
                  this.selected_website_channel_array.push(this.websitesUrls[rr.key]);
                }
              } else {
                rr.check = false;
                if (this.selected_website_array.includes(rr.key))
                  this.selected_website_array.splice(
                    this.selected_website_array.indexOf(rr.key),
                    1
                  );
                if (
                  this.selected_website_channel_array.includes(this.websitesUrls[rr.key])
                )
                  this.selected_website_channel_array.splice(
                    this.selected_website_channel_array.indexOf(
                      this.websitesUrls[rr.key]
                    ),
                    1
                  );
              }
            }
          }
        }
      }
    },
    addToChanged(d) {
      if (!this.saveTrack.includes(d.link)) {
        this.saveTrack.push(d.link);
        this.saveData.push(d);
      }
    },
    saveNow() {
      let self = this;
      if (!self.saveData.length) {
        alert("No Change");
        return;
      }
      this.loader = true;
      let payload = {
        admin_table: self.saveData,
        website: self.selected_website,
        item_category: self.device,
      };
      const url = "/api/websites/save_compliance_new";
      self.$http.post(url, payload).then(
        (response) => {
          alert("Saved");
          self.refresh();
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          self.refresh();
          alert("Error in Saving");
        }
      );
    },

    getEmailList() {
      let self = this;
      this.loader = true;
      const url = "/api/spider/list_email";
      self.$http.post(url, {}).then(
        (response) => {
          self.emailList = response.body.data.sort();
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    filterSpiders(action) {
      if (
        this.successFlag &&
        this.failedFlag &&
        this.warningFlag &&
        this.unscheduledFlag &&
        this.runningFlag
      ) {
        this.toggleFlags(false);
      }
      switch (action) {
        case "succeded":
          this.successFlag = !this.successFlag;
          break;
        case "failed":
          this.failedFlag = !this.failedFlag;
          break;
        case "warning":
          this.warningFlag = !this.warningFlag;
          break;
        case "running":
          this.runningFlag = !this.runningFlag;
          break;
        case "unscheduled":
          this.unscheduledFlag = !this.unscheduledFlag;
          break;
        case "all":
          this.toggleFlags(true);
        default:
          break;
      }
      let allData = JSON.parse(JSON.stringify(this.spiderDataFull));
      allData.forEach((data) => {
        data.spiders = data.spiders.filter((val) => {
          if (this.failedFlag) {
            if (val.final_status == "failed") return true;
          }
          if (this.unscheduledFlag) {
            if (val.final_status == "unscheduled") return true;
          }
          if (this.runningFlag) {
            if (val.final_status == "running") return true;
          }
          if (this.successFlag) {
            if (val.final_status == "succeded" && !val.log[val.log.length - 1].info)
              return true;
          }
          if (this.warningFlag) {
            if (val.final_status == "succeded" && val.log[val.log.length - 1].info)
              return true;
          }
          return false;
        });
      });
      allData = allData.filter((data) => data.spiders.length);
      this.spiderData = JSON.parse(JSON.stringify(allData));
    },
    toggleFlags(bool) {
      this.warningFlag = bool;
      this.failedFlag = bool;
      this.runningFlag = bool;
      this.successFlag = bool;
      this.unscheduledFlag = bool;
    },
    getData() {
      let self = this;
      this.loader = true;
      let payload = {
        websites: this.selected_website_array,
        timestamp: moment(this.date.startDate).format("YYYY-MM-DD"),
      };
      if (self.emailFilter) payload.email_id = self.emailFilter;
      const url = "/api/spider/status";
      self.$http.post(url, payload).then(
        (response) => {
          self.spiderDataFull = response.body.data;
          self.spiderCount = response.body.spider_count;
          self.websiteCount = response.body.website_count;
          this.filterSpiders("all");
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
  },
};
</script>
<style>
/* #missing-spider-data_length select {
  width: 50% !important;
} */
#missing-spider-field_length select {
  width: 50% !important;
}
#empty-spider-field_length select {
  width: 50% !important;
}
#missing-spider-field_filter {
  display: none;
}
#missing-spider-databutton.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
_filter {
  display: none;
}
#empty-spider-field_filter {
  display: none;
}
.modal-title {
  font-weight: 600 !important;
  font-family: "poppins" !important;
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color) !important;
  border: none !important;
  font-family: "poppins" !important;
  border-radius: 5px 0px 0px 0px !important;
  word-break: break-all;
}

.modal-header .close {
  color: black !important;
  text-shadow: none !important;
  position: absolute !important;
  top: -2px !important;
  right: -6px !important;
  font-size: 30px !important;
  background: var(--primary_brand-10) !important;
  opacity: inherit !important;
  padding: 5px 10px !important;
  border-radius: 25px !important;
}
@media (max-width: 770px) {
  #missing-spider-data_filter {
    margin-top: -38px !important;
  }
}
</style>
<style scoped>
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
.top-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.custom_websiteMenu {
  border: 1px solid silver;
  background: white;
  width: max-content;
  position: absolute;
  z-index: 1;
  height: 300px;
  overflow-y: scroll;
  margin-left: -5px;
  border-radius: 0px 0px 5px 5px;
}

.custom_websiteMenuItems {
  font-size: 11px;
  color: var(--primary_brand);
}

.custom_optgroup {
  font-weight: bolder;
  padding-left: 9px;
  font-size: 13px;
}

.custom_option {
  padding: 8px 8px 8px 18px;
  display: flex;
  align-items: center;
  font-family: "heebo" !important;
  border-bottom: 1px solid var(--base_color-20);
}

.custom_option input {
  margin-right: 5px;
  font-size: 11px;
  accent-color: var(--primary_brand);
  width: 15px;
  height: 15px;
  font-family: "poppins";
}

.custom_option:hover {
  background: var(--base_color-10) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.custom_option.active {
  background: var(--primary_brand-60);
  color: white;
  font-weight: bolder;
}

.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
  width: 36%;
  margin-right: 8px;
  background: var(--base_color-5) !important;
  color: var(--primary_brand-80) !important;
}
.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  border-radius: 5px;
  background: white;
  justify-content: space-between;
  padding: 7px;
  height: 34px !important;
}

.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

select option {
  text-transform: capitalize !important;
  padding: 10px 0px !important;
}

select {
  font-family: "Poppins", sans-serif !important;
}

customSelect {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
}

.customSelect:focus {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: 600 !important;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
  border: none !important;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
.linkHover:hover {
  text-decoration: underline;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.card_vivo {
  background-color: #0072ba !important;
  border: 1px solid #0072ba !important;
}
.card_realme {
  background-color: #f3b821 !important;
  border: 1px solid #f3b821 !important;
}
.card_redmi {
  background-color: #f56628 !important;
  border: 1px solid #f56628 !important;
}

.badge {
  padding: 5px;
  font-size: 13px;
}
.redbg {
  background: #ffd1d1;
  color: inherit;
}
.ybg {
  background: #ffff9c;
  color: inherit;
}
.greenbg {
  color: green;
  cursor: pointer;
}
.highcharts-figure .chart-container {
  width: 300px;
  height: 200px;
  float: left;
}
.cursorPointer:hover {
  cursor: pointer;
}
.thead-normal th,
.tbody-normal td {
  border: 1px solid silver !important;
}
.thead-normal tr {
  background: rgb(138, 135, 232);
  color: white;
}
.saveBtn {
  background-color: #b4ffb3;
  border-radius: 0;
  height: 30px;
  border: none;
  width: 60px;
}
.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none; /* iOS Safari */
  -youbkit-user-select: none; /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE 10+ and Edge */
  user-select: none;
}
.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  background: white;
  justify-content: space-between;
  padding: 6px;
  height: 30px;
}
.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.customInput {
  border-radius: 5px !important;
  height: 35px !important;
  border: 1px solid var(--primary_brand-60);
  width: 220px;
  outline: none;
}
.customInput:focus {
  border: 1px solid var(--primary_brand) !important;
}
.customInput::placeholder {
  color: var(--primary_brand-40);
}
.custom_websiteMenu {
  border: 1px solid silver;
  background: white;
  width: max-content;
  position: absolute;
  z-index: 1;
  height: 300px;
  overflow-y: scroll;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
.custom_websiteMenuItems {
  font-size: 11px;

  color: #5c6873;
}
.custom_optgroup {
  font-weight: bolder;
  padding-left: 9px;
}
.custom_option {
  padding-left: 18px;
}
.custom_option:hover {
  background: #23a8d8;
  color: white;
  font-weight: bolder;
}
.custom_option.active {
  background: #1a88af;
  color: white;
  font-weight: bolder;
}
.mycol {
  padding-right: 15px !important;
  padding-left: 15px !important;
}
.mycols:first-child {
  padding-right: 2px !important;
}

.mycols:last-child {
  padding-left: 2px;
}
.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}
.mycols:nth-child(7n) {
  padding-left: 15px !important;
}
.mycols:nth-child(6n) {
  padding-right: 15px !important;
}
#spiderTable td {
  padding: 7px !important;
  font-family: "Poppins" sans-serif !important;
}
#spiderTable {
  background: transparent !important;
}
#spiderTable td:first-child {
  text-align: left !important;
  background: var(--background) !important;
  font-weight: bolder !important;
}
.spiderlogsmsg {
  max-height: 178px;
  overflow: auto;
  max-width: 440px;
  font-size: 11px;
  background: whitesmoke;
  padding: 10px;
}

.left-card {
  display: flex;
  justify-content: space-between;
}
.right-card {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 1520px) {
  .top-card {
    flex-direction: column;
    justify-content: flex-start;
    gap: 10px;
  }
  .datebox {
    padding-bottom: 0;
  }
}

@media (max-width: 580px) {
  .top-card {
    flex-direction: row;
    gap: 10px;
  }
  .left-card {
    flex-direction: column;
    gap: 10px;
    height: 50%;
  }

  .left-card > div {
    width: 100% !important;
  }
  .right-card {
    flex-direction: column;
    gap: 10px;
  }

  .right-card > div {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .right-card button {
    margin-right: 0 !important;
  }
}

@media (max-width: 790px) {
  .scrolled-table {
    max-width: 100vw;
    overflow-x: auto;
  }
  .action-btn-grp {
    width: 50%;
  }
}
</style>
